import { FiltroBusquedaCorreccionMonetaria } from "../models/filtroBusqueda";
import { useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from "react";
import { Grid2 } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { getListYears } from "../utils/optionsYears";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import InputText from "../../../../components/inputs/yup/materialui/inputText";

interface IProps{
    onSubmit: (e: FiltroBusquedaCorreccionMonetaria) => void;
}

const optionsYears = getListYears();

export const FormularioBusquedaCorreccionMonetaria : React.FC<IProps> = ({onSubmit}) => {

    const anioActual = new Date().getFullYear();

    const validationSchema = yup.object<FiltroBusquedaCorreccionMonetaria>().shape({
        mesComercial: yup.string().required(),
        valoresActivos: yup.boolean(),
        anioComercial: yup.number().required("Campo requerido")
                    .max(anioActual, "El año comercial no puede superar el actual")
    })

    const {
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
    } = useForm<FiltroBusquedaCorreccionMonetaria>({ 
        resolver: yupResolver(validationSchema), 
        mode: "onChange" }
    )

    useEffect(() => {
        setValue("anioComercial", anioActual - 1);
        setValue("valoresActivos", true);
        setValue("mesComercial", "Diciembre");
    }, [])

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputSelect
                        name="anioComercial"
                        control={control}
                        label="Año comercial"
                        options={optionsYears}
                        error={errors.anioComercial}
                        clearable={false}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputText
                        label="Mes comercial"
                        name="mesComercial"
                        control={control}
                        readonly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }} >
                    <InputSwitch
                        name="valoresActivos"
                        control={control}
                        label="Filtrar valores activos"
                        error={errors.valoresActivos}
                      />
                </Grid2>
            </Grid2>
            <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<FilterListIcon />}>
                    Buscar
                </MButton>
            </Grid2>
        </form>
    ); 
}